import getConfig from "src/config/appConfig";
import agendaApiConfig from "./agendaApiConfig";

const TipoExamenService = {
  async getAll(sue_correl = null) {
    //return await agendaApiConfig.get("/imagenologia/tipo_examen");
    const { IMAGENOLOGIA } = getConfig();
    let query = {};
    if (IMAGENOLOGIA == "") {
      query = null;
    } else {
      query = { ser_codigo: IMAGENOLOGIA, sue_correl };
    }
    return await agendaApiConfig.get("/imagenologia/tipo_examen", {
      params: {
        ...query,
      },
    });
  },
  async getExamenes(codeExamen = 0) {
    //return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`);
    const { IMAGENOLOGIA } = getConfig();
    let query = {};
    if (IMAGENOLOGIA == "") {
      query = null;
    } else {
      query = { ser_codigo: IMAGENOLOGIA };
    }
    return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`, {
      params: {
        ...query,
      },
    });
  },
};

export default TipoExamenService;
